exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-input-checkbox[data-v-50cfefc6] {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.custom-input-checkbox input[data-v-50cfefc6] {\n    width: 16px;\n    height: 16px;\n    border-radius: 6px;\n}\n", ""]);

// exports
